import React from "react"
import { NavLink } from "react-router-dom"
import useRequireAuth from "../../hooks/use-require-auth"
import { useTranslation } from "react-i18next"

export function TopRightToolbar({ customerLogo }) {
    const auth = useRequireAuth()
    const [t] = useTranslation()
    return (
        <ul className="navbar-nav ms-auto">
            {customerLogo ? (
                <li className="nav-item">
                    <img className={"nav-link"} src={customerLogo} alt="" />
                </li>
            ) : null}
            <li className="nav-item dropdown">
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end">
                    <span className="dropdown-header">15 Notifications</span>
                    <div className="dropdown-divider"></div>
                    <button type="button" className="dropdown-item">
                        <i className="fas fa-envelope me-2"></i>{' '}4 new messages
                        {' '}<span className="float-end text-muted text-sm">3 mins</span>
                    </button>
                    <div className="dropdown-divider"></div>
                    <button type="button" className="dropdown-item">
                        <i className="fas fa-users me-2"></i>{' '}8 friend requests
                        {' '}<span className="float-end text-muted text-sm">12 hours</span>
                    </button>
                    <div className="dropdown-divider"></div>
                    <button type="button" className="dropdown-item">
                        <i className="fas fa-file me-2"></i>{' '}3 new reports
                        {' '}<span className="float-end text-muted text-sm">2 days</span>
                    </button>
                    <div className="dropdown-divider"></div>
                    <button type="button" className="dropdown-item dropdown-footer">See All Notifications</button>
                </div>
            </li>
            <li className="nav-item">
                <NavLink to="/loginpage" onClick={() => auth.signout()} className="nav-link">
                    <i
                        style={{ fontSize: "150%" }}
                        title={t("app.menu.logout")}
                        className="nav-icon fas fa-sign-out-alt"
                    ></i>
                </NavLink>
            </li>
        </ul>
    )
}
